export const COVERAGE_GROUP_COMPANIES_SET_LOADING =
  'COVERAGE_GROUP_COMPANIES/SET_LOADING';
export const COVERAGE_GROUP_COMPANIES_SET_ERROR =
  'COVERAGE_GROUP_COMPANIES/SET_ERROR';
export const COVERAGE_GROUP_COMPANIES_SET_COVERAGE_GROUP_COMPANIES =
  'COVERAGE_GROUP_COMPANIES/SET_COVERAGE_GROUP_COMPANIES';
export const COVERAGE_GROUP_COMPANIES_SET_PAGINATION =
  'COVERAGE_GROUP_COMPANIES/SET_PAGINATION';

export const COVERAGE_GROUP_COMPANIES_FETCH_COVERAGE_GROUP_COMPANIES =
  'COVERAGE_GROUP_COMPANIES/FETCH_COVERAGE_GROUP_COMPANIES';
export const COVERAGE_GROUP_COMPANIES_CLEAR_ERROR =
  'COVERAGE_GROUP_COMPANIES/CLEAR_ERROR';

export const COVERAGE_GROUP_COMPANIES_GET_COVERAGE_GROUP_COMPANIES =
  'COVERAGE_GROUP_COMPANIES/GET_COVERAGE_GROUP_COMPANIES';
export const COVERAGE_GROUP_COMPANIES_GET_PAGINATION =
  'COVERAGE_GROUP_COMPANIES/GET_PAGINATION';
export const COVERAGE_GROUP_COMPANIES_GET_LOADING =
  'COVERAGE_GROUP_COMPANIES/GET_LOADING';
export const COVERAGE_GROUP_COMPANIES_GET_ERROR =
  'COVERAGE_GROUP_COMPANIES/GET_ERROR';
